import { Component, OnInit, Inject } from "@angular/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';
import { AppConfig } from '../../../core/configs/app-config';
import { HttpClient,  } from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { Router } from '@angular/router';
import {MedewerkerPlanning} from '../../../model/dto/medewerkers/overzicht';
import {PlanningOverzicht} from '../../../model/dto/planning/overzicht';
import {formatDate} from '@angular/common';
import 'fullcalendar';
import 'fullcalendar-scheduler';
import * as jQuery from "jquery";
import { PlanningMdwAfdelingDialog } from './afdelingdialog/afdelingdialog';
import { PlanningMdwRelatieDialog } from './relatiedialog/relatiedialog';
import { PlanningMdwKeuzeDialog } from './keuzedialog/keuzedialog';
import { PlanningMdwBewerkenDialog } from './bewerkendialog/bewerkendialog';
import {UserService } from "../../../core/services/user.service";
import {
  ElementRef, AfterViewInit, NgZone, ViewChild, OnDestroy,
} from '@angular/core';


import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

(window as any).$ = (window as any).jQuery = jQuery;
declare let $: any;
@Component({
    selector   : 'planningoverzicht',
    templateUrl: './planningoverzicht.component.html',
    styleUrls  : ['./planningoverzicht.component.scss']
})



export class PlanningOverzichtComponent implements OnInit
{
  Medewerkers: MedewerkerPlanning[] = [];
  PlanningOverzicht: PlanningOverzicht[] = [];
  selectedAfdelingen: any[] = [];
  cbChecked : boolean;
  config: any;
  aantaldagen : number = 14;
    constructor(private router: Router, public dialog: MatDialog, private _fuseTranslationLoaderService: FuseTranslationLoaderService, private userService:UserService, @Inject(HttpClient) private http?: HttpClient)
    {
        this.config = {
            "SERVERPROTOCOL": AppConfig.ApiProtocol,
            "SERVERURL": AppConfig.ApiLoginHost,
            "SERVERPORT": AppConfig.ApiPort,
            "APPLICATIONID": AppConfig.ApiApplicationId,
            "METHOD": AppConfig.ApiMethod,
            "LOGINURL": AppConfig.ApiLoginUrl,
            "STACKURL": AppConfig.ApiUrl
          };
        this._fuseTranslationLoaderService.loadTranslations(english, dutch);

    }

    datetot: Date;
    datebegin: Date;
    loading: boolean = false;

    updateMedewerkers(){

     var body = {
      "AfdIDs": this.selectedAfdelingen,
      "InplanbareMedewerker": this.cbChecked
     };


    let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/medewerkersoverzicht";

    var post = this.http.post(conString, body);
    post.subscribe(     
    (results: any) => {
      this.Medewerkers.length = 0;
      this.Medewerkers.push({ id:0, title:"Nog te plannen", afdeling:"nog te plannen"});
    for (var result of  results){ 
        this.Medewerkers.push({ id:result["MedewerkerID"], title:result["CplNaam"], afdeling:result["Afdeling"]});
    }  

    $('#calendar').fullCalendar("refetchResources");
    },
    (error) => {
    console.error(error);
    });
    
    }



  ngOnInit() {
    this.reloadSheduler();
  }

  onMin1Week(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    console.log(this.datebegin);
    this.datebegin.setDate(this.datebegin.getDate() - 7);
    console.log(this.datebegin);
   // (document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    console.log(this.datebegin);
    this.UpdateCalendar();
  }

  onMin1Day(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin.setDate(this.datebegin.getDate() - 1);
    //(document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    this.UpdateCalendar();
  }
  
  onPlus1Day(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin.setDate(this.datebegin.getDate() + 1);
    //(document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    this.UpdateCalendar();
  }

  onPlus1Week(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin.setDate(this.datebegin.getDate() + 7);
    this.UpdateCalendar();
  
   

  }

  onToday(){
    if (this.loading == true){
      return;
    }
    this.loading = true;
    this.datebegin = new Date();
    this.datebegin.setDate( this.datebegin.getDate());
    this.UpdateCalendar();
    
  }

  changeDate(date){
    this.datebegin = date.value;
    this.UpdateCalendar();
  }

  UpdateCalendar(){
    this.PlanningOverzicht = [];
    //(document.getElementById('mat-input-0') as HTMLInputElement).value = formatDate(this.datebegin, 'dd/MM/yyyy', 'en');
    $('#calendar').fullCalendar("gotoDate", this.datebegin );
    this.datetot = new Date(this.datebegin);
    console.log(this.datebegin.getDate());
    this.datetot.setDate(this.datebegin.getDate() + this.aantaldagen);

    let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/overzicht/" + formatDate(this.datebegin, 'dd-MM-yyyy', 'en') + "/"+ formatDate(this.datetot, 'dd-MM-yyyy', 'en');
   console.log(conString);
    var get = this.http.get(conString);
    get.subscribe(     
    (results:any) => {
    for (var result of  results){ 
      var title = "";
      if (result["BedrijfAfkorting"] == "Nr0") {
        title = result["Categorie"] + " " + result["Onderwerp"];         
      } else {
        title = result["BedrijfAfkorting"] + " " + result["Onderwerp"];
      }
      this.PlanningOverzicht.push({ id:result["PlanningID"], resourceId:result["MedewerkerID"], start:result["Start"],end:result["Tot"],title:title, patroon:result["Patroon"], onderwerpID:result["onderwerpID"]});
      }  
      $('#calendar').fullCalendar('removeEvents');
      $('#calendar').fullCalendar('addEventSource', this.PlanningOverzicht);
      this.loading = false;
    } )
    
  }

  afdelingFilterDialog(){
    const dialogRef = this.dialog.open(PlanningMdwAfdelingDialog, {
      disableClose: true,
      height: '500px',
      data: {afdeling: this.selectedAfdelingen}
    });

    dialogRef.afterClosed().subscribe(selectedAfdelingen => {
      this.selectedAfdelingen = selectedAfdelingen;
      this.updateMedewerkers();
    });
  }

  relatiesFilterDialog(){
    const dialogRef = this.dialog.open(PlanningMdwRelatieDialog, {
      disableClose: true,
      height: '500px',
      data: {afdeling: this.selectedAfdelingen}
    });

    dialogRef.afterClosed().subscribe(selectedAfdelingen => {
      this.selectedAfdelingen = selectedAfdelingen;
    });
  }

  reloadSheduler(){
    $('#calendar').fullCalendar('destroy');
    this.Medewerkers = [];
    this.PlanningOverzicht = [];

    this.cbChecked = true;

    var body = {
      "AfdIDs": this.selectedAfdelingen,
      "InplanbareMedewerker": this.cbChecked
     };

    this.updateMedewerkers();

    this.datetot = new Date();
    this.datetot.setDate( this.datetot.getDate() + this.aantaldagen );
    this.datebegin = new Date();
    this.datebegin.setDate( this.datebegin.getDate());

 

   let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/overzicht/" + formatDate(this.datebegin, 'dd-MM-yyyy', 'en') + "/"+ formatDate(this.datetot, 'dd-MM-yyyy', 'en');

    var get = this.http.get(conString);
    get.subscribe(     
    (results:any) => {
    for (var result of  results){ 
      var title = "";
      if (result["BedrijfAfkorting"] == "Nr0") {
        title = result["Categorie"] + " " + result["Onderwerp"];      
      } else {
        title = result["BedrijfAfkorting"] + " " + result["Onderwerp"];
      }
      this.PlanningOverzicht.push({ id:result["PlanningID"], resourceId:result["MedewerkerID"], start:result["Start"],end:result["Tot"],title:title, patroon:result["Patroon"], onderwerpID:result["onderwerpID"]});
    }  

    $('#calendar').fullCalendar({
      aspectRatio: 1,
      scrollTime: '00:00', // undo default 6am scrollTime
      header: {
        left: '',
        center: 'title',
        right: '' 
          //...other buttons
     },
     weekNumbers: true,
      defaultView: 'timelineThreeDays',
      views: {
        timelineThreeDays: {
          type: 'timeline',
          duration: { days: this.aantaldagen }
        }
      },
      eventRender : function(event, element) {
        element[0].title = event.title;
     },
     dayClick: (calEvent, jsEvent, view) => {
      const dialogRefBewerken = this.dialog.open(PlanningMdwBewerkenDialog, {
        disableClose: true,
        maxHeight: '100vh',
        data: {calEvent: calEvent, onlyToday: false}
      });
      dialogRefBewerken.afterClosed().subscribe(result => {
        this.UpdateCalendar();
      });

     },
     eventClick: (calEvent, jsEvent, view) => {
       if (calEvent.patroon > 0){
        const dialogRef = this.dialog.open(PlanningMdwKeuzeDialog, {
          maxHeight: '100vh',
          disableClose: true,
          data: {calEvent: calEvent, onlyToday: false}
        });
        dialogRef.afterClosed().subscribe(result => {
          this.UpdateCalendar();
        });
       } else {
        const dialogRef = this.dialog.open(PlanningMdwBewerkenDialog, {
          maxHeight: '100vh',
          disableClose: true,
          data: {calEvent: calEvent, onlyToday: true}
        });
        dialogRef.afterClosed().subscribe(result => {
          this.UpdateCalendar();
        });
       }
  
      // change the border color just for fun
      $(this).css('border-color', 'red');
  
    },
      resourceLabelText: 'Medewerkers',
      resourceGroupField: 'afdeling',
      resources: this.Medewerkers,
      events:this.PlanningOverzicht,
      schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
      slotDuration: '24:00'
    });
    
    },
    (error) => {
    console.error(error);
    });
    
  }




}
